module.exports = __webpack_public_path__ + "static/media/header_left_menu.9440d223.svg";